import { render } from "./tips-component.vue?vue&type=template&id=4cdf67ea&scoped=true"
import script from "./tips-component.vue?vue&type=script&lang=js"
export * from "./tips-component.vue?vue&type=script&lang=js"

import "./tips-component.vue?vue&type=style&index=0&id=4cdf67ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdf67ea"]])

export default __exports__